import { Group } from "@models/ISchema";
import { subjectAdapter } from "./subject";
import { courseAdapter } from "./course";
import { AdaptedGroup } from "../models";

export const groupAdapter = (group: Group): AdaptedGroup => {
  const isNumeric = (value: string) => /^-?\d+$/.test(value);

  const adapted: AdaptedGroup = {
    ...((group ?? {}) as any),
    subject: subjectAdapter(group?.subject),
    course: courseAdapter(group?.course),
    link: Array.isArray(group?.links) && group.links.length > 0 ? group.links[0] : {},
    labels: (group?.labels ?? []).filter(label => {
      const code = label && typeof label === "object" && "code" in label ? label.code : null;
      return code && !isNumeric(code);
    }),
  };

  return adapted;
};
